export const LOCALES = ['en-US']
